
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/category/[uid]",
      function () {
        return require("private-next-pages/projects/category/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/category/[uid]"])
      });
    }
  